import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Portfolio from './pages/Portfolio';
import QuemSouEu from './pages/QuemSouEu';
import StoryMaker from './pages/StoryMaker';
import VideoMaker from './pages/VideoMaker';
import AdminLogin from './pages/AdminLogin';
import AdminQuotes from './pages/AdminQuotes';

import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="App">
      <div className="profile-container">
        <img src="/alice-perfil.png" alt="Alice Barcelos" className="profile-image" />

        <h1 className="profile-name">Alice Barcelos</h1>
        <p className="profile-description">
          🎥 Story Maker & Video Maker <br />
          Registrando momentos em memórias ✨
        </p>

        <div className="links-container">

          <a
            href="https://api.whatsapp.com/message/AC4STW4ZAAAHN1"
            target="_blank"
            rel="noopener noreferrer"
            className="link-button whatsapp"
          >
            WhatsApp
          </a>

          <Link to="/portfolio" className="link-button portfolio">
            Portfólio
          </Link>

          <a
            href="https://www.instagram.com/bliss.momentos_/"
            target="_blank"
            rel="noopener noreferrer"
            className="link-button instagram"
          >
            Instagram
          </a>
        </div>

        <footer className="footer">
          <Link to="/admin" className="admin-link">
            Área Bliss
          </Link>
          <p>© 2025 Alice Barcelos — Story Maker</p>
        </footer>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/quem-sou-eu" element={<QuemSouEu />} />
        <Route path="/story-maker" element={<StoryMaker />} />
        <Route path="/video-maker" element={<VideoMaker />} />
        <Route path="/orcamento" element={<Navigate to="/admin/financeiro" replace />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/financeiro" element={<AdminQuotes />} />
        <Route path="/admin/financeiro/novo" element={<AdminQuotes />} />
        <Route path="/admin/financeiro/:entryId/editar" element={<AdminQuotes />} />
        <Route path="/admin/orcamentos" element={<Navigate to="/admin/financeiro" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
